export const ToasterTypes = {
  Info: 'info',
  Success: 'success',
  Warning: 'warning',
  Error: 'error',
  Default: 'default',
  Dark: 'dark',
};
